<template>
    <div>
        <div class="w3-row"
            v-bind:class="openUserCard ? 'content-sidebar-header sidebars-40-60' : 'flow-margin-right'">
            <div class="w3-col w3-quarter">
                <content-header v-bind:title="$t(ftitle)"></content-header>
            </div>
            <div class="w3-col w3-quarter w3-right flow-content-actions-header flow-margin-bottom">
                <div class="flow-padding-top w3-large">
                    <span class="fa fa-stack cursor-pointer w3-right flow-form-action active w3-ripple flow-blue-color w3-margin-right"
                          @click='refreshUsers'
                          :title="$t('refresh')">
                        <i class="fa fa-stack-2x fa-circle  w3-text-white"></i>
                        <i class="fa fa-stack-1x fa-sync-alt fa-inverse flow-blue-color w3-xlarge"
                           v-bind:class="isRefreshInProgress ? 'w3-spin' : ''">
                        </i>
                    </span>

                </div>
            </div>
        </div>

        <loading v-if="!openUserCard" v-bind:dspin="displaySpinner"></loading>

            <!-- CONTENT START -->
            <div v-if="!displaySpinner" class="w3-white w3-striped w3-margin-bottom zero-top flow-card blue-top w3-animate-opacity"
                 v-bind:class="openUserCard ? 'w3-container content-sidebars sidebars-40-60' : 'w3-container flow-main-content'"
                 id="users-table">

                    <!-- MAIN CONTENT CARD START -->
                    <div v-bind:class="openUserCard ? 'zero w3-col content-sidebar-left' : 'zero w3-row-padding'">

                        <table class="w3-table w3-striped w3-bordered flow-table"
                               v-bind:style="{display: !displaySpinner ? 'table' : 'none'}">
                            <thead class="">
                            <th>{{ $t("name") }}</th>
                            <th>{{ $t("role") }}</th>
                            <th v-if="!openUserCard">{{ $t("username") }}</th>
                            <th v-if="!openUserCard">{{ $t("wards") }}</th>
                            <th>{{ $t("physician") }}</th>
                            <th v-if="!openUserCard">{{ $t("email") }}</th>
                            </thead>
                            <tr v-for="userOverview in users"
                                v-bind:class="userOverview.id === selectedUserId ? 'active' : ''"
                                v-bind:id="userOverview.id">

                                <td class="primary" @click="displayUser(userOverview.id)">
                                    {{ userOverview.user.firstName + " " + userOverview.user.lastName }}
                                </td>

                                <td class="flow-user-role">
                                    <user-role v-bind:role="userOverview.user.role"></user-role>
                                </td>

                                <td v-if="!openUserCard">
                                    {{ userOverview.username }}
                                </td>

                                <td  v-if="!openUserCard">
                                    <p v-for="(ward, idx) in userOverview.lwWards">
                                        <span v-if="idx === 2">
                                            <i class="fa cursor-pointer flow-blue-color" @click="displayUser(userOverview.id)">...</i>
                                        </span>
                                        <span v-if="idx >= 0 && idx < 2">
                                            {{ (idx > 0 ? ', ' : '') + ward.displayName }}
                                        </span>
                                    </p>
                                </td>

                                <td>
                                    <span v-if="userOverview.user.physician">
                                        {{ userOverview.user.physician.name }}
                                    </span>
                                </td>

                                <td v-if="!openUserCard">
                                    {{ userOverview.user.email }}
                                </td>
                            </tr>
                        </table>
                    </div>

                    <div class="w3-col content-sidebar-right top-from-header w3-padding-small flow-padding-top"
                         v-bind:class="openUserCard ? 'w3-animate-right' : 'w3-animate-left'"
                         v-if="openUserCard">
                        <i class="fa fa-times fa-2x w3-text-gray cursor-pointer card-closer flow-padding-top" @click="closerUserCard" :title="$t('close')"></i>
                        <user class="flow-padding-top" v-bind:userId="selectedUserId"></user>
                    </div>
            </div>
            <!-- CONTENT END -->
    </div>

</template>

<script>
    import Vue from 'vue';
    import { EventBus } from "../main";
    import ContentHeader from "@/components/common/ContentHeader";
    import Loading from "@/components/common/Loading";
    import User from "./User.vue";
    import UserRole from "../components/common/UserRole";

    let frc = Vue.prototype.$frc;

    export default {
        name: "Users",
        components: {UserRole, User, ContentHeader, Loading},
        props: ['ftitle'],
        data: function () {
            return {
                users: [],
                displaySpinner: false,
                selectedUser: {},
                openUserCard: false,
                selectedUserId: '',
                addNewUserSelected: false,
                isRefreshInProgress: false,
                displaySecondLoader: false
            }
        },
        created() {
            EventBus.$on("userIdUpdated", this.onUserSave);
            EventBus.$on("userIdDeleted", this.onUserDelete);
        },
        beforeDestroy() {
            EventBus.$off("userIdUpdated", this.onUserSave);
            EventBus.$off("userIdDeleted", this.onUserDelete);
        },
        mounted() {
            this.getUsers();
        },
        methods: {
            getUsers: function () {
                const app = this;
                app.displaySpinner = true;
                app.isRefreshInProgress = true;
                frc.getUsers().then(function (res) {
                    app.users = res.data;
                    app.sortUsers();
                    app.isRefreshInProgress = false;
                    app.stopAllLoaders();
                }).catch(function(e) {
                    console.log(e);
                });
            },
            sortUsers() {
                this.users.sort(function(u1, u2) {
                    let n1 = u1.user.firstName + " " + u1.user.lastName;
                    let n2 = u2.user.firstName + " " + u2.user.lastName;

                    return n1.toLowerCase().localeCompare(n2.toLowerCase());
                });
            },
            getAndUpdateUserOverview: function(userId) {
                console.log("Updating user: " + userId);
                const app = this;
                frc.getUserOverview(userId)
                    .then(function(res) {
                        app.displaySpinner = true;
                        app.displaySpinner = false;

                        for (let idx in app.users) {
                            let u = app.users[idx];
                            if (u.id === userId) {
                                app.users[idx] = res.data;
                                break;
                            }
                        }

                        setTimeout(Vue.scrollToElementWithId(app.selectedUserId), 1);
                    })
                    .catch(function(e) {
                       console.log(e);
                    });
            },
            displayUser: function(userId) {
                this.selectedUserId = userId;
                this.openUserCard = true;
                this.addNewUserSelected = false;
            },
            getSelectedUserId: function() {
                return this.selectedUserId;
            },
            onUserSave: function(userId) {
                console.log("UserId Saved: " + userId);
                if (null != userId) {
                    this.selectedUserId = userId;
                }
                this.addNewUserSelected = false;
                this.getAndUpdateUserOverview(userId);
                Vue.scrollToElementWithId(this.selectedUserId);
            },
            closerUserCard: function() {
                this.openUserCard = false;
                this.selectedUserId = undefined;
            },
            onUserDelete: function(userId) {
                this.displaySpinner = true;
                this.displaySpinner = false;
                this.closerUserCard();

                for (let idx in this.users) {
                    let u = this.users[idx];
                    if (u && u.id === userId) {
                        this.users.splice(idx, 1);
                        break;
                    }
                }
            },
            refreshUsers: function() {
                if (!this.isRefreshInProgress) {
                    this.getUsers();
                    this.displaySecondLoader = true;
                }
            },
            stopAllLoaders: function() {
                this.displaySpinner = false;
                this.displaySecondLoader = false;
            }
        }
    }
</script>

